import { render, staticRenderFns } from "./ChannelsCell.vue?vue&type=template&id=1dce5e6f&scoped=true"
import script from "./ChannelsCell.vue?vue&type=script&lang=js"
export * from "./ChannelsCell.vue?vue&type=script&lang=js"
import style0 from "./ChannelsCell.vue?vue&type=style&index=0&id=1dce5e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce5e6f",
  null
  
)

export default component.exports